import { configureStore } from '@reduxjs/toolkit';
import { portfolioApi } from '../API/config';

export const store = configureStore({
  reducer: {
    [portfolioApi.reducerPath]: portfolioApi.reducer,
  },
});
